import { FilePlus, Loader2 } from "lucide-react";
import { cn } from "@/utils/css";

export const BatchDropzone = ({ isUploading, isDragging, onClick, onDragEnter, onDragLeave, onDragOver, onDrop }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={isUploading}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={onDragOver}
            onDrop={onDrop}
            className={cn(
                "relative w-full h-[159px] rounded-[10px] border-[1.5px] border-dashed flex flex-col items-center justify-center gap-4 px-4 transition-colors",
                {
                    "border-cm-p-accent-200": isUploading,
                    "border-cm-p-accent-400 hover:border-cm-p-accent-600": !isUploading && !isDragging,
                    "border-cm-p-accent-600": isDragging,
                    "cursor-not-allowed": isUploading,
                    "cursor-pointer": !isUploading,
                },
            )}
        >
            <span
                aria-hidden
                className={cn(
                    "absolute inset-0 rounded-[10px] bg-cm-p-container-green pointer-events-none transition-opacity",
                    isDragging ? "opacity-100" : "opacity-50",
                )}
            />
            <span className="relative flex flex-col items-center gap-4">
                {isUploading ? (
                    <>
                        <Loader2 className="size-[22px] text-cm-p-accent-400 animate-spin" />
                        <span className="text-cm-p-text-primary text-base">Uploading file...</span>
                    </>
                ) : (
                    <>
                        <FilePlus className="size-8 text-cm-p-text-primary" strokeWidth={1.5} />
                        <span className="flex flex-col gap-1 items-center text-center">
                            <span className="text-base">
                                <span className="text-cm-p-accent-600 font-medium underline">Click to upload</span>
                                <span className="text-cm-p-text-primary"> or drag and drop here</span>
                            </span>
                            <span className="text-xs text-cm-p-text-secondary">CSV or XLSX (max. 50 MB)</span>
                        </span>
                    </>
                )}
            </span>
        </button>
    );
};
